$('form#cadastrardetido').submit(function(){
	
	var campo = {
		"detido" : $('input[name=detido]', this),
		"matricula" : $('input[name=matricula]', this),
		"raio" : $('input[name=raio]', this),
		"cela" : $('input[name=cela]', this),
		"visitante_nome" : $('input[name=visitante_nome]', this),
		"visitante_endereco" : $('input[name=visitante_endereco]', this),
		"visitante_numero" : $('input[name=visitante_numero]', this),
		"visitante_bairro" : $('input[name=visitante_bairro]', this),
		"visitante_complemento" : $('input[name=visitante_complemento]', this),
		"visitante_cidade" : $('input[name=visitante_cidade]', this),
		"visitante_estado" : $('input[name=visitante_estado]', this)
	}


	$('form#cadastrardetido .campo-erros ul li').remove();
	var erros = [];

	if( campo.detido.val().length < 3 ){
		campo.detido.addClass('is-err');
		erros.push("Nome do Detido");
	} else {
		campo.detido.removeClass("is-err");
	}

	if( !campo.matricula.val()) {
		campo.matricula.addClass('is-err');
		erros.push("Número da matrícula");
	} else {
		campo.matricula.removeClass("is-err");
	}

	if( campo.visitante_nome.val().length < 3 ){
		campo.visitante_nome.addClass('is-err');
		erros.push("Nome completo do visitante");
	} else {
		campo.visitante_nome.removeClass("is-err");
	}

	if( campo.visitante_endereco.val().length < 3 ){
		campo.visitante_endereco.addClass('is-err');
		erros.push("Endereço do visitante");
	} else {
		campo.visitante_endereco.removeClass("is-err");
	}

	if( campo.visitante_numero.val().length == 0 ){
		campo.visitante_numero.addClass('is-err');
		erros.push("Número do logradouro do visitante");
	} else {
		campo.visitante_numero.removeClass("is-err");
	}

	if( campo.visitante_bairro.val().length == 0 ){
		campo.visitante_bairro.addClass('is-err');
		erros.push("Bairro do logradouro do visitante");
	} else {
		campo.visitante_bairro.removeClass("is-err");
	}

	if( campo.visitante_cidade.val().length == 0 ){
		campo.visitante_cidade.addClass('is-err');
		erros.push("Cidade do logradouro do visitante");
	} else {
		campo.visitante_cidade.removeClass("is-err");
	}

	if( campo.visitante_estado.val().length < 2 ){
		campo.visitante_estado.addClass('is-err');
		erros.push("Estado do logradouro do visitante");
	} else {
		campo.visitante_estado.removeClass("is-err");
	}		

	// if( !Valida.email( campo.email.val() ) ){
	// 	campo.email.addClass('is-err');
	// 	erros.push("E-mail");		
	// }else {
	// 	campo.email.removeClass('is-err');
	// }

	// if( campo.email.val() !== campo.emailb.val() ){
	// 	campo.emailb.addClass('is-err');
	// 	erros.push("Confirme o E-mail");	
	// }else {
	// 	campo.emailb.removeClass('is-err');
	// }

	// if( campo.senha.val().length < 6){
	// 	campo.senha.addClass('is-err');
	// 	erros.push("Senha");	
	// }else {
	// 	campo.senha.removeClass('is-err');
	// }

	// if( campo.senha.val() !== campo.senhab.val() ){
	// 	campo.senhab.addClass('is-err');
	// 	erros.push("Confirmar Senha");	
	// }else {
	// 	campo.senhab.removeClass('is-err');
	// }

	if( erros.length !== 0 ){
		$.each(erros, function(key, val){
			$('form#cadastrardetido .campo-erros ul').append("<li>Verifique o campo <strong>\""+ val +"\"</strong>.</li>");
		});
		return false;
	}
});

$('#cadastrardetido #visitante_cep').blur(function(event){

	// var cep = $('input[name=buscacep]', this).val();
	var cep = $("#visitante_cep").val();
	
	if( cep.length < 9 )
	{
		$("#cadastrardetido input[name=visitante_endereco]").val('');
		$("#cadastrardetido input[name=visitante_bairro]").val('');
		$("#cadastrardetido input[name=visitante_cidade]").val('');
		$("#cadastrardetido input[name=visitante_estado]").val('');

		return false;
	}
	
	var c = cep.replace("-", "");
	var cepUrl = "//api.awsli.com.br/v2/cep?cep=" + c;
	
	$.ajax({
		url: cepUrl
	})
	.done(function(response) {
		$("#cadastrardetido input[name=visitante_endereco]").val(response.logradouro);
		$("#cadastrardetido input[name=visitante_bairro]").val(response.bairro);
		$("#cadastrardetido input[name=visitante_cidade]").val(response.cidade);
		$("#cadastrardetido input[name=visitante_estado]").val(response.estado);
	})
	.fail(function(response) {
		alert(response.statusText);
	})

	return false;
});


$('.lista-detidos .expand').click(function() {
	var $this = $(this);

	$this.parent('.detido-header').next('.content-detido').slideToggle(350);
});

/*
	Ao clicar no botão de voltar, ele volta para a página anterior
*/
$(document).ready(function(){
	if($(".minha_conta-editar_detido").length){
		$(".btn.btn-voltar").click(function(evt){
			evt.preventDefault();
			location.replace(document.referrer);
		});

		if(!document.referrer.match(/minha-conta/gmi))
			$("#fluxo-compra").val(1);
	}
});